import { combineReducers } from "redux";
import loginReducer from "./login/loginReducer";
import loadingReducer from "./loading/loadingReducer";

const rootReducer = combineReducers({
  loadingState: loadingReducer,
  loginState: loginReducer,
});

export default rootReducer;
